import { createFileRoute } from '@tanstack/react-router'
import { withSessionRedirect } from '../lib/require-session.ts'
import { fetchHierarchy } from '../lib/hierarchy-api.ts'
import { getComposioStatus, listComposioAccounts } from '../lib/composio-api.ts'
import { ComposioPage } from '../components/ComposioPage.tsx'

export const Route = createFileRoute('/composio')({
  loader: async () =>
    withSessionRedirect(async () => {
      const [status, tree] = await Promise.all([
        getComposioStatus(),
        fetchHierarchy(),
      ])
      const rootId = tree.roots[0]?.id ?? ''
      const accounts = rootId ? await listComposioAccounts(rootId) : null
      return {
        status,
        rootId,
        roots: tree.roots.map((r) => ({ id: r.id, name: r.name })),
        accounts,
      }
    }),
  component: ComposioRoute,
})

function ComposioRoute() {
  const data = Route.useLoaderData()
  return <ComposioPage {...data} />
}
